export default "__VITE_ASSET__DkCvkkzw__"